import u from '@/utils'
import axios from 'axios'

const state = {
  requestTimeline: [],
  automationRequestCount: [],
  automationRequestCountOnly: [],
  selectedAutomationRequest: {},
  selectedSelfService: {}
}

const mutations = {
  setRequestTimeline(state, requestTimeline) {
    state.requestTimeline = requestTimeline
  },
  setAutomationRequestCount(state, automationRequestCount) {
    state.automationRequestCount = automationRequestCount
  },
  setAutomationRequestCountOnly(state, automationRequestCountOnly) {
    state.automationRequestCountOnly = automationRequestCountOnly
  },
  setSelectedAutomationRequest(state, selectedAutomationRequest) {
    state.selectedAutomationRequest = selectedAutomationRequest
  },
  setSelectedSelfService(state, selectedSelfService) {
    state.selectedSelfService = selectedSelfService
  }
}

const actions = {
  async fetchRequestTimeline({ commit }, requestId) {
    let response = await axios.get(
      `/api/v1/automationRequests/${requestId}/timeline`
    )
    if (response.data._embedded) {
      let requestTimeline = [
        ...response.data._embedded.automationRequestTimelines
      ]
      requestTimeline = requestTimeline.map(step => u.processResp(step))
      commit('setRequestTimeline', requestTimeline)
      return requestTimeline
    } else {
      return []
    }
  },

  async getAutomationRequest({ commit }, requestId) {
    commit('setSelectedAutomationRequest', null)
    let response = await axios.get(`/api/v1/automationRequests/${requestId}`)
    let request = response.data
    request = u.processResp(request)
    commit('setSelectedAutomationRequest', request)
    return request
  },

  async getAutomationRequestByNumber(context, requestId) {
    let response = await axios.get(
      `/api/v1/automationRequests/number/${requestId}`
    )
    let request = response.data
    request = u.processResp(request)
    return request
  },

  async getSelectedSelfService({ commit }, requestId) {
    commit('setSelectedSelfService', null)
    let response = await axios.get(
      `/api/v1/automationRequests/${requestId}/selfService`
    )
    let request = response.data
    request = u.processResp(request)
    commit('setSelectedSelfService', request)
    return request
  },


  async fetchAutomationRequestCountOnly({ commit }) {
    let response = await axios.get(`/api/v1/automationRequests/count`)
    if (response.data._embedded) {
      let requestCount = [...response.data._embedded.measureByDateModels]
      requestCount = requestCount.map(step => u.processResp(step))
      commit('setAutomationRequestCountOnly', requestCount)
      return requestCount
    } else {
      return 0
    }
  }
}

export default {
  state,
  actions,
  mutations
}
